import {PERIOD_KEY_TYPE, SALES_STATUS_KEY_TYPE, SALES_TARGET_KEY_TYPE} from "@/shared/model";
import * as z from "zod";
import {ManagerInformationModel} from "../../tax-corporation";
import {SalesManagementDetailResModel} from "./SalesManagementDetailResModel";

const commonSchema = z.object({
	id: z.string().nullable(),
	period: PERIOD_KEY_TYPE.nullable(),
	target: SALES_TARGET_KEY_TYPE.nullable(),
	status: SALES_STATUS_KEY_TYPE.nullable(),
	department: z.string(),
	manager: ManagerInformationModel.model.nullable(),
	firstApprover: ManagerInformationModel.model,
	firstApproverStatus: SALES_STATUS_KEY_TYPE.nullable(),
	firstApprovedAt: z.string().nullable(),
	firstApproverComment: z.string().nullable(),
	secondApprover: ManagerInformationModel.model,
	secondApproverStatus: SALES_STATUS_KEY_TYPE.nullable(),
	secondApprovedAt: z.string().nullable(),
	secondApproverComment: z.string().nullable(),
	details: z.array(SalesManagementDetailResModel.model)
});

const yearlySchema = commonSchema.extend({
	period: z.literal("YEARLY"),
	year: z.string()
});

const monthlySchema = commonSchema.extend({
	period: z.literal("MONTHLY"),
	yearMonth: z.string()
});

const weeklySchema = commonSchema.extend({
	period: z.literal("WEEKLY"),
	fromDate: z.string(),
	toDate: z.string()
});

const schema = z.discriminatedUnion("period", [yearlySchema, monthlySchema, weeklySchema]);

const model = schema.transform((values) => ({
	...values
}));

export const SalesManagementResModel = {schema, model};
export type ISalesManagementResModel = z.infer<typeof SalesManagementResModel.model>;
export const DEFAULT_SALES_MANAGEMENT_RES: ISalesManagementResModel = {
	id: null,
	period: "YEARLY",
	target: "PERSONAL",
	status: "DEFAULT",
	department: "",
	manager: {
		id: null,
		name: null
	},
	year: "",
	firstApprover: {
		id: null,
		name: null
	},
	firstApproverStatus: "DEFAULT",
	firstApprovedAt: "",
	firstApproverComment: "",
	secondApprover: {
		id: null,
		name: null
	},
	secondApproverStatus: "DEFAULT",
	secondApprovedAt: "",
	secondApproverComment: "",
	details: []
};
